import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@fortawesome/fontawesome-free/css/all.css";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";

const requireComponent = require.context(
  // The relative path of the components folder
  "./components/BaseComp",
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  /Base[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName);

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split("/")
        .pop()
        .replace(/\.\w+$/, "")
    )
  );

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  );
});

Vue.config.productionTip = false;
export const EventBus = new Vue({
  methods: {
    Printing(val) {
      this.$emit("PrintEvent", val);
    },
  },
});

Vue.mixin({
  methods: {
    CurrentOld(defount = new Date()) {
      let currentDate = new Date(defount);
      let month = currentDate.getMonth() + 1;
      let year = currentDate.getFullYear();
      let day = currentDate.getDate();
      let tom = currentDate.getDate() + 1;
      let hours = currentDate.getHours();
      let minits = currentDate.getMinutes();
      // console.log();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      if (tom < 10) tom = "0" + tom;

      let date = year + "-" + month + "-" + day;
      // let date = "2021-01-23";
      let tomorrow = year + "-" + month + "-" + tom;
      let time = hours + ":" + minits + ":00";
      let Thismonth = year + "-" + month + "-01";
      return { date, time, Thismonth, tomorrow };
    },
    Current(defount = new Date()) {
      let currentDate = new Date(defount);

      let month = currentDate.getMonth() + 1;
      let year = currentDate.getFullYear();

      let yest = new Date(currentDate.setDate(currentDate.getDate() - 1));
      let tom = new Date(currentDate.setDate(currentDate.getDate() + 1));

      let hours = currentDate.getHours();
      let minits = currentDate.getMinutes();
      let time = hours + ":" + minits + ":00";

      let date = this.GetDateFormat(currentDate);
      // let date = "2020-07-01";
      let tomorrow = this.GetDateFormat(tom);
      let yesterDay = this.GetDateFormat(yest);
      let Thismonth = year + "-" + (month < 10 ? `0${month}` : month) + "-01";
      return { date, time, Thismonth, tomorrow, yesterDay };
    },

    GetDateFormat(currentDate) {
      let month = currentDate.getMonth() + 1;
      let year = currentDate.getFullYear();
      let day = currentDate.getDate();

      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;

      return year + "-" + month + "-" + day;
    },
  },
});
Vue.filter("MoneySigns", function(value) {
  if (!value) return value;
  // return "kkk";
  const { CashSypol } = store.getters.CashSigns.find(element => {
    return element.Cashcode == value;
  }) || { CashSypol: value };
  // console.log(CashSypol);
  return CashSypol;
  // return Signs.CashSypol;
});
Vue.filter("filterCode", function(value) {
  if (!value) return value;
  // return "kkk";
  // console.log(value);
  // if (value && value.match(RegExp("000A$"))) return "Advanced Payment";
  return new RegExp("0000$").exec(value) ? "Old Balance" : value;
});

// console.log(router);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount("#app");
